module.exports = __webpack_public_path__ + "images/check-new.svg";